export var highContrastModeConfig = {
  colorDivider: '#444',
  controlBorderColor: '#444',
  controlBorderColorHover: '#444',
  controlBorderColorSubtle: '#444',
  surfaceBorderColor: '#444'
};